import { gql } from '@apollo/client'

export default gql`
  fragment JobCardComponent on Job {
    id
    intro
    location
    publishedAt
    slug
    title
  }
`
